import React from "react";
import ProjectLayout from "../layouts/ProjectLayout";
import projectsData from "../data/projectsData";

const Basement429 = () => {
  const data = projectsData.basement429;
  return <ProjectLayout {...data} />;
};

export default Basement429;
